import COUNTRIES from '../countries.translations'

import translations from './barium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/barium'

export const barium: Metal = {
  id: 23,
  slug: 'barium',
  name: t.name,
  symbol: 'Ba',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Mangampet, barium mine (India)',
      region: t.mine0Region,
      slug: 'mangampet',
      coordinates: [79.28, 14.05],
    },
    {
      name: 'Elko, barium mine (United States)',
      region: t.mine1Region,
      slug: 'elko',
      coordinates: [-115.76, 40.83],
    },
    {
      name: 'Battle Mountain, barium mine (United States)',
      region: t.mine2Region,
      slug: 'battle-mountain',
      coordinates: [-116.93, 40.64],
    },
    {
      name: 'Majiang, barium mine (China)',
      region: t.mine3Region,
      slug: 'majiang',
      coordinates: [107.6, 26.49],
    },
    {
      name: 'Lipu, barium mine (China)',
      region: t.mine4Region,
      slug: 'lipu',
      coordinates: [110.39, 24.49],
    },
  ],
  // Barite mine production, not barium metal — see the `**` footnote.
  countries: [
    { name: COUNTRIES.india, percent: 24 },
    { name: COUNTRIES.china, percent: 19.4 },
    { name: COUNTRIES.morocco, percent: 9.2 },
    { name: COUNTRIES.kazakhstan, percent: 6 },
    { name: COUNTRIES.mexico, percent: 3 },
  ],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: null, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: null, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
